export interface FinancialDashboardTotalMonthData {
    month: number,
    year: number,

    commissionValue?: number,
    cashbackValuePartsfy?: number,
    cashbackValueRepairer?: number,
    cashbackValueSupplier?: number,

    orderQuantity?: number,
    orderQuantityUntilToday?: number,
    orderQuantityByWorkingDay?: number,

    transactedValueFromBillable?: number,
    transactedValueFromBillableUntilToday?: number,
    transactedValueFromBillableByWorkingDay?: number,

    transactedValueTotal?: number,
    transactedValueTotalUntilToday?: number,
    transactedValueTotalByWorkingDay?: number,

    totalWorkingDays?: number,
    totalWorkingDaysUntilSelectedDate?: number,

    isBestMonth?: boolean,
    isActualMonth?: boolean,
    isLastYearMonth?: boolean
}

export function createDefaultFinancialDashboardActualMonth(month: number, year: number): FinancialDashboardTotalMonthData {
    return {
        month,
        year,
        commissionValue: 0,
        cashbackValuePartsfy: 0,
        cashbackValueRepairer: 0,
        cashbackValueSupplier: 0,
        orderQuantity: 0,
        orderQuantityUntilToday: 0,
        orderQuantityByWorkingDay: 0,
        transactedValueFromBillable: 0,
        transactedValueFromBillableUntilToday: 0,
        transactedValueFromBillableByWorkingDay: 0,
        transactedValueTotal: 0,
        transactedValueTotalUntilToday: 0,
        transactedValueTotalByWorkingDay: 0,
        totalWorkingDays: 0,
        totalWorkingDaysUntilSelectedDate: 0,
        isBestMonth: false,
        isActualMonth: true,
        isLastYearMonth: false
    };
}
